import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { css } from '@emotion/react';
import { GlobalMenu } from 'scene/Layout/GlobalMenu';
import { checkIsShowScrollBar } from 'stores/ScrollBarDisplay';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'model/IAppState';
import * as rdUserService from 'services/User';
import { isNil } from 'lodash';
import {
    getFrontendUrl,
} from 'helpers/Uri';

import * as rdEnum from 'helpers/enum';
import { useRDNavigate } from 'helpers/useRDNavigate';

interface Props {
    title?: string;
    children: React.ReactNode;
    sceneId?: string;
    langScreenID?: string;
    metaKeywords?: string;
    canonicalHref?: string;
}
export const MainLayoutPage = ({ title, children, sceneId, langScreenID, metaKeywords, canonicalHref }: Props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const rdNav = useRDNavigate();
    const isScrollbarVisible = useSelector((state: IAppState) => {
        return state.isShowScrollBar.isShowScrollBar
    });



    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.style.overflowY = isScrollbarVisible ? 'scroll' : 'hidden';
            // containerRef.current.style.paddingRight = isScrollbarVisible ? '15px' : '0px';
        }
    }, [isScrollbarVisible]);

    const doGetIsShowMaintenance = async (maintenanceCodeFromUrl: string) => {
        let response = await rdUserService.isShowMaintenance();
        if (response.status) {
            if (response.data) {

                let isShowMaintenance = response.data.isShow;
                let maintenanceTestingCode = response.data.maintenanceCode;
                if (isShowMaintenance && maintenanceTestingCode !== maintenanceCodeFromUrl) {
                    navigate(rdNav(`${getFrontendUrl()}/${rdEnum.enumPageLink.Maintenance}`));
                }
            }
        }

    }


    useEffect(() => {
        //remove chat box for maintenance page
        const chatID = "divChatBox";

        if (location.pathname.includes("/maintenance")) {
            const chatele = document.getElementById(chatID);
            if (chatele) chatele.remove();
        }

    }, [location]);



    useEffect(() => {

        let maintenanceTestingCodeFromUrl = searchParams.get('maintenance') || "";
        let codeInStorage = localStorage.getItem("MaintenanceTestingCode") || "";
        if (isNil(codeInStorage) || codeInStorage == "") {
            if (!isNil(maintenanceTestingCodeFromUrl) && maintenanceTestingCodeFromUrl != "") {
                localStorage.setItem("MaintenanceTestingCode", maintenanceTestingCodeFromUrl || "");
            }
        }
        codeInStorage = localStorage.getItem("MaintenanceTestingCode") || "";
        doGetIsShowMaintenance(codeInStorage || "");

        //save it in storage for the users login back from AD B2C
        const evar25Value = searchParams.get('evar25') || "";
        if (window.s && evar25Value != "") {
            window.s.eVar25 = evar25Value;
            window.s.t();
        }
        localStorage.setItem("mrm", evar25Value || "");

    }, []);

    return (
        <HelmetProvider>
            <Helmet>
                {/*<Helmet meta={[{ name: "keywords", content: metaKeywords }]}*/}
                {/*    link={[{ rel: "canonical", href: canonicalHref }]}*/}
                {/*>*/}
                <title>{title}</title>
            </Helmet>
            {/* <div id="divPage" css={css``} className={sceneId}> */}
            {/* <nav className="nav-menu" style={{ height: '106px', position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
                    <GlobalMenu  />
                </nav> */}
            <div className='d2c-container' ref={containerRef} >
                {children}
            </div>
            {/* </div> */}
        </HelmetProvider>
    );

}
